<ng-content></ng-content>

<i class="search-icon fa-solid fa-magnifying-glass"></i>
<ng-container *ngIf="canClear">
	<button class="clear-button icon-only transparent" (click)="onClear()">
		<i class="fa-solid fa-xmark"></i>
	</button>
</ng-container>
